import api from './api';

// Every screen of this app is a QR channel (QR / MOO / KIOSK / salon), so the menu
// endpoints are always asked for "QR and POS" categories only. Without from_qr the
// backend also returns the POS-only categories, which are for the POS till.
const QR_CHANNEL = { from_qr: 1 };

class OrderService {
  getListCategory(dataForm) {
    return api.post('/order/get-categories', { ...dataForm, ...QR_CHANNEL });
  }

  // MTH045: newest published items in the branch's menuset (post-login promo popup).
  getNewestItems(dataForm) {
    return api.post('/order/get-newest-items', { ...dataForm, ...QR_CHANNEL });
  }

  // Auto-translate menu item names into the selected locale (cached backend-side).
  translateMenu(dataForm) {
    return api.post('/order/translate-menu', dataForm);
  }

  searchItem(dataForm) {
    return api.post('/order/search-item', { ...dataForm, ...QR_CHANNEL });
  }

  saveOrder(dataForm) {
    return api.post('/order/save-order', dataForm);
  }

  saveOrderQR(dataForm) {
    return api.post('/order/save-order-qr', dataForm);
  }
  
  checkoutSessionStripe(dataForm) {
    return api.post('/checkout-session-stripe', dataForm);
  }

  checkCheckoutSessionStripe(dataForm) {
    return api.post('/check-checkout-session-stripe', dataForm);
  }

  checkoutHppAirwallex(dataForm) {
    return api.post('/airwallex/checkout-hpp', dataForm);
  }

  checkHppAirwallex(dataForm) {
    return api.post('/airwallex/check-hpp', dataForm);
  }

  // Qlub hosted payment: the API answers the Qlub redirect URL for a saved order.
  checkoutQlub(dataForm) {
    return api.post('/qlub/checkout', dataForm);
  }

  saveTransactionByOrder(dataForm) {
    return api.post('/order/save-transaction-by-order', dataForm);
  }

  // from_qr: the item is priced for a QR channel, so Price Schedules apply (POS sends none).
  getItemDetail(dataForm) {
    return api.post('/order/item-detail', { ...dataForm, ...QR_CHANNEL });
  }

  getSlidesHomePage(dataForm) {
    if(dataForm.isMintyApi) {
      // return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/slides`,dataForm);
      return api.post('/slides', dataForm);
    }
  }

  checkAvailableOrdering(dataForm) {
    return api.post('/order/check-available-ordering', dataForm);
  }

  getOrderByOrderId(dataForm) {
    return api.post('/get-order-by-order-id', dataForm);
  }

  // Short-lived socket token scoped to this one order. Returns { enabled: false }
  // when realtime is switched off server-side, which is a normal answer.
  getWsTokenForOrder(dataForm) {
    return api.post('/ws-token/order', dataForm);
  }

  checkTransactionPaid(dataForm) {
    return api.post('/check-transaction-paid', dataForm);
  }

  checkItemsSelectedStock(dataForm) {
    return api.post('/order/check-items-selected-stock', dataForm);
  }

  getOrdersByMember(branch_code, status, page) {
    return api.get('/get-orders-by-member/' + branch_code + '/' + status + '/' + page);
  }

  getOrdersByNonMember(dataForm) {
    return api.post('/get-orders-by-non-member', dataForm);
  }

  getOrdersByTable(dataForm) {
    return api.post('/get-orders-by-table', dataForm);
  }

  // MTH090: voucher the pay-later table session is locked to, so the cart can
  // keep showing it on the second and later orders.
  // Body: { branch_code, table_code }
  getTableVoucherLock(dataForm) {
    return api.post('/order/get-table-voucher-lock', dataForm);
  }

  getOrdersHistory(dataForm) {
    return api.post('/get-orders-history', dataForm);
  }

  reload(dataForm) {
    return api.post('/order/reload', { ...dataForm, ...QR_CHANNEL });
  }

  // M986 follow-up: delivery days/slots for MOO Delivery, plus the earliest slot.
  getDeliverySlots(dataForm) {
    return api.post('/order/delivery-slots', dataForm);
  }

  // M986 follow-up: delivery fee for a postal code (fixed or by distance).
  getDeliveryFee(dataForm) {
    return api.post('/order/delivery-fee', dataForm);
  }

  // M988: street address for a postal code, to fill in the delivery address.
  lookupAddress(dataForm) {
    return api.post('/order/address-lookup', dataForm);
  }

  retryOrder(dataForm) {
    return api.post('/retry-order', dataForm);
  }

  deleteItemInOrderFailed(dataForm) {
    return api.post('/delete-item-in-order-failed', dataForm);
  }

  getOrderStatus(dataForm) {
    return api.post('/get-order-status', dataForm);
  }

  getSlidesLandingPage(dataForm) {
    if(dataForm.isMintyApi) {
      return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/slides-for-moo`,dataForm);
      // return api.post('/slides-for-moo', dataForm);
    }
  }

  checkbranchStatus(dataForm) {
    return api.post('/check-branch-status', dataForm);
  }

  retryOrderPayLater(dataForm) {
    return api.post('/retry-order-paylater', dataForm);
  }

  requestActionRequired(dataForm) {
    return api.post('/request-action-required', dataForm);
  }

  getOrderByOrderIdForActionRequired(dataForm) {
    return api.post('/get-order-by-order-id-for-action-required', dataForm);
  }

  closeOrderAfterCheckedWasTenderOnPos(dataForm) {
    return api.post('/close-order-after-checked-was-tender-on-pos', dataForm);
  }

  handleRefundOrder(dataForm) {
    return api.post('/handle-refund-order', dataForm);
  }

  saveTransactionByOrderForPayLater(dataForm) {
    return api.post('/order/save-transaction-by-order-for-paylater', dataForm);
  }

  saveTransactionByOrderAfterPayStripe(dataForm) {
    return api.post('/order/save-transaction-by-order-after-pay-stripe', dataForm);
  }

  saveTransactionByOrderAfterPayMintyWallet(dataForm) {
    return api.post('/order/save-transaction-by-order-after-pay-minty-wallet', dataForm);
  }

  retryOrderWalletNotEnough(dataForm) {
    return api.post('/retry-order-wallet-not-enough', dataForm);
  }

  getNumberOfGuests(dataForm) {
    return api.post('/order/get-number-of-guests', dataForm);
  }

  chooseNumberOfGuests(dataForm) {
    return api.post('/order/choose-number-of-guests', dataForm);
  }

  updateStatusOrderPayFirst(dataForm) {
    return api.post('/update-status-order-payfirst', dataForm);
  }

  checkShowUpsellItems(dataForm) {
    return api.post('/order/check-show-upsell-items', dataForm);
  }

  getUpsellItems(dataForm) {
    return api.post('/order/get-upsell-items', dataForm);
  }

  checkPromoCode(dataForm) {
    return api.post('/order/check-promo-code', dataForm);
  }
  
  getBranches(dataForm) {
    return api.post('/physical-branch/get-branches', dataForm);
  }

  getPhysicalBranches(dataForm) {
    return api.post('/get-physical-branches', dataForm);
  }

  checkMerchantAndBranch(dataForm) {
    return api.post('/check-merchant-and-branch', dataForm);
  }
}

export default new OrderService();
